import { withColor } from "@commonlibs";
import clsx from "clsx";
import QRCode, { QRCodeProps } from "react-qr-code";

export interface QRProps extends Omit<QRCodeProps, "fgColor" | "bgColor" | "ref" | "size" | "width" | "height"> {
    size?: string | number;
    qrRef?: React.Ref<HTMLDivElement>;
}

function QR({ className, size, qrRef, color, ...rest }: QRProps) {
    return (
        <div ref={qrRef}>
            <QRCode className={clsx("qr", className)} data-testid="QR" fgColor={color} css={{ width: size, height: size }} {...rest} />
        </div>
    );
}

export default withColor(QR, "text");
